<script setup>
import {onMounted, reactive, ref} from 'vue'
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js";
import {listClubCourse} from "@/api/club/club.js";
import {listCoach} from "@/api/coach/coach.js";
import {addLesson, editLesson, getLesson, listLessonStudent} from "@/api/lesson/lesson.js";
import {lessonStateEnum} from "@/enum/lessonStateEnum.js";

const loading = ref(false)
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)
// 是否选择时间
const isSelectTime = ref(false)
// 学员状态枚举
const studentState = lessonStateEnum
// 课堂学员上限人数
const studentLimit = ref(0)
onMounted(async () => {
  isEdit.value = Boolean(route.query.lessonId)
  await handleGetCourse()
  await handleGetCoach()
  if (isEdit.value) await getDetail(route.query.lessonId)
})
/*获取课程记录信息*/
const getDetail = async (lessonId) => {
  loading.value = true
  try {
    const res = await getLesson(lessonId)
    if (!res) throw new Error("null")
    Object.assign(ruleForm, res);
    console.log("ruleForm", ruleForm)
    console.log("res.students", res.students)
    studentLimit.value = res.studentLimit
    isSelectTime.value = true
    // 选择课程后查询学生信息
    await handleGetStudent()
    ruleForm.students.forEach(i => {
      i.isOld = true
    })
    loading.value = false
  } catch (e) {
    console.log(e)
    if (e.message === "null") {
      ElMessage({
        type: "warning",
        message: "暂无此课程记录数据",
        duration: 3000,
        onClose: () => {
          router.push("/listClubCourseRecord")
        }
      })
    }
  }
}

/*获取课程信息相关*/
// 翻页信息：当前页数、当前页条目数、总条目数
const pageCourse = ref(1)
const pageSizeCourse = ref(5)
const totalCourse = ref(0)
const courseLoading = ref(false)
const courseList = ref([])
// 获取课程信息
const handleGetCourse = async () => {
  courseLoading.value = true
  let param = {
    page: pageCourse.value,
    pageSize: pageSizeCourse.value
  }
  const res = await listClubCourse(param)
  courseList.value = res.list
  totalCourse.value = Number(res.total)
  courseLoading.value = false
}
// 课程翻页
const handleChangeCoursePage = () => {
  handleGetCourse()
}
// 选择课程
const handleCourseChange = (e) => {
  const item = courseList.value.find((item) => item.goodsId === e)
  ruleForm.courseId = item.goodsId
  ruleForm.goodsName = item.goodsName
  ruleForm.courseName = item.goodsName
  studentLimit.value = item.studentLimit
  // 选择课程后查询学生信息
  handleGetStudent()
}

/*获取教练信息相关*/
// 翻页信息：当前页数、当前页条目数、总条目数
const pageCoach = ref(1)
const pageSizeCoach = ref(5)
const totalCoach = ref(0)
const coachLoading = ref(false)
const coachList = ref([])
// 获取教练信息
const handleGetCoach = async () => {
  coachLoading.value = true
  let param = {
    page: pageCoach.value,
    pageSize: pageSizeCoach.value
  }
  const res = await listCoach(param)
  coachList.value = res.list
  totalCoach.value = Number(res.total)
  coachLoading.value = false
}
// 教练列表翻页
const handleChangeCoachPage = () => {
  handleGetCoach()
}
// 选择教练
const handleCoachChange = (e) => {
  const item = coachList.value.find((item) => item.coachId === e)
  ruleForm.coachId = item.coachId
  ruleForm.coachName = item.coachName
}

/*获取学员信息相关*/
// 翻页信息：当前页数、当前页条目数、总条目数
const pageStudent = ref(1)
const pageSizeStudent = ref(5)
const totalStudent = ref(0)
const studentLoading = ref(false)
const students = ref([])
// 获取学员信息
const handleGetStudent = async () => {
  studentLoading.value = true
  let param = {
    page: pageStudent.value,
    pageSize: pageSizeStudent.value
  }
  let data = {
    courseId: ruleForm.courseId,
    keyword: ""
  }
  const res = await listLessonStudent(param, data)
  students.value = res.list
  totalStudent.value = Number(res.total)
  studentLoading.value = false
}
// 学员列表翻页
const handleChangeStudentPage = () => {
  handleGetStudent()
}
// 选择学员
const handleStudentChange = (e, index) => {
  // 校验人数上限
  if(!checkStudentLimit(index)) return
  const item = students.value.find(i => i.studentId === e)
  // 校验学员是否存在
  if (ruleForm.students.some(stu => stu.studentName === item.studentName)) {
    ruleForm.students.splice(index, 1)
    ElMessage.error("该学员存在，请勿重复添加")
  } else {
    ruleForm.students[index].studentId = item.studentId
    ruleForm.students[index].studentName = item.studentName
    ruleForm.students[index].studentState = studentState[0].stateId
    ruleForm.students[index].stateName = studentState[0].stateName
  }
}
// 校验课堂人数上限
const checkStudentLimit = (index) => {
  let isPass = true
  // 校验人数上限
  let listLimit = 0
  ruleForm.students.forEach(i => {
    if (i.studentState !== "CANCELLED") listLimit++
  })
  if (listLimit > studentLimit.value) {
    ElMessage.error(`课堂学员上限为${studentLimit.value}，请修改学员信息`)
    ruleForm.students.splice(index, 1)
    isPass = false
  }
  return isPass
}

/*表单信息*/
// 表单大小
const formSize = ref('large')
// 表单锚点
const ruleFormRef = ref()
// 表单信息
const ruleForm = reactive({
  goodsName: null,
  lessonStartTime: null,
  courseId: null,
  coachId: null,
  coachName: null,
  students: [],
  lessonState: null,
})

// 新增课程记录校验规则
const rulesOne = {
  courseId: [
    {required: true, message: "请选择课程", trigger: "change"}
  ],
  lessonStartTime: [
    {required: true, message: "请选择时间", trigger: "change"}
  ],
  coachId: [
    {required: true, message: "请选择教练", trigger: "change"}
  ]
}
// 表单校验规则
const rules = ref(rulesOne)

// 表单校验
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      await createLesson()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 创建课程记录
const createLesson = async () => {
  console.log("ruleForm:", ruleForm)
  try {
    if (isEdit.value) {
      await editLesson(ruleForm)
    } else {
      ruleForm.lessonState = "PENDING"
      await addLesson(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    loading.value = false
    router.push('/listClubCourseRecord')
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单信息
const resetForm = () => {
  router.back()
}

/*选择课程记录状态相关*/
const handleLessonStateChange = () => {
  console.log("ruleForm.lessonState", ruleForm.lessonState)
  if (ruleForm.lessonState === "CANCELLED") {
    ruleForm.students.forEach(i => {
      i.studentState = "CANCELLED"
    })
  }
}

/*选择时间相关*/
// 时间改变
const handleTimeChange = (e) => {
  console.log("handleTimeChange", e)
  ruleForm.courseId = null
  ruleForm.goodsName = null
  ruleForm.coachId = null
  ruleForm.coachName = null
  ruleForm.students = []
  isSelectTime.value = Boolean(ruleForm.lessonStartTime)
}

/*添加学员相关*/
// 添加学员
const addStudent = () => {
  if (ruleForm.students.length === 0 || ruleForm.students[ruleForm.students.length - 1].studentName) {
    ruleForm.students.push({
      studentId: null,
      studentName: null,
      studentState: null,
      stateName: null,
      isOld: false
    });
  } else {
    ElMessage.error("请先选择未填写的学员信息后再添加新的学员！");
  }
}
// 修改学员状态
const handleStudentStateChange = (index) => {
  // 校验学员上限
  checkStudentLimit(index)
}
// 删除学员
const handleRemoveStudent = (index) => {
  ruleForm.students.splice(index, 1)
  ruleFormRef.value.validate("students")
}

</script>

<template>
  <div class="container_box">
    <v-container class="flex_center">
      <el-form
          ref="ruleFormRef"
          style="max-width: 100%"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          class="demo-ruleForm"
          :size="formSize"
          status-icon
          v-loading="loading"
      >
        <el-form-item label="课程：" prop="courseId">
          <el-select
              v-model="ruleForm.courseId"
              placeholder="请选择课程"
              size="large"
              style="width: 350px"
              :loading="courseLoading"
              @change="handleCourseChange"
              :disabled="!isSelectTime || isEdit"
          >
            <el-option
                v-for="item in courseList"
                :key="`courseList${item.courseId}`"
                :label="item.goodsName"
                :value="item.goodsId"
            />
            <template v-if="!loading && !courseList.some(res => res.goodsId === ruleForm.courseId) && ruleForm.courseId !== null" #header>
              当前已选：
              <el-option
                  :label="ruleForm.courseName"
                  :value="ruleForm.courseId"
              />
            </template>

            <template #footer>
              <div class="flex_center">
                <el-pagination
                    size="small"
                    background
                    layout="prev, pager, next"
                    :total="totalCourse"
                    class="mt-4"
                    v-model:current-page="pageCourse"
                    v-model:page-size="pageSizeCourse"
                    @current-change="handleChangeCoursePage"
                />
              </div>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="时间：" prop="lessonStartTime">
          <el-date-picker
              style="width: 350px"
              v-model="ruleForm.lessonStartTime"
              type="datetime"
              placeholder="请选择课程时间"
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
              @change="handleTimeChange"
              :disabled="isEdit"
          />
        </el-form-item>
        <el-form-item label="状态：" prop="lessonState" v-if="isEdit">
          <el-select
              v-model="ruleForm.lessonState"
              placeholder="请选择状态"
              size="large"
              style="width: 350px"
              @change="handleLessonStateChange"
              class="mg_r_1"
          >
            <el-option
                v-for="ruleForm in studentState"
                :key="`lessonState${ruleForm.lessonState}`"
                :label="ruleForm.stateName"
                :value="ruleForm.stateId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="教练：" prop="coachId">
          <el-select
              v-model="ruleForm.coachId"
              placeholder="请选择教练"
              size="large"
              style="width: 350px"
              :loading="coachLoading"
              @change="handleCoachChange"
              :disabled="!isSelectTime || ruleForm.lessonState === 'CANCELLED'"
          >
            <el-option
                v-for="item in coachList"
                :key="`coachList${item.coachId}`"
                :label="item.coachName"
                :value="item.coachId"
            />
            <template v-if="!loading && !coachList.some(res => res.coachId === ruleForm.coachId) && ruleForm.coachId !== null" #header>
              当前已选：
              <el-option
                  :label="ruleForm.coachName"
                  :value="ruleForm.coachId"
              />
            </template>

            <template #footer>
              <div class="flex_center">
                <el-pagination
                    size="small"
                    background
                    layout="prev, pager, next"
                    :total="totalCoach"
                    class="mt-4"
                    v-model:current-page="pageCoach"
                    v-model:page-size="pageSizeCoach"
                    @current-change="handleChangeCoachPage"
                />
              </div>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="学员：" prop="students">
          <div>
            <div v-for="(item, index) in ruleForm.students" class="mg_b_1 flex_left">
              <el-select
                  v-model="item.studentId"
                  placeholder="请选择学员"
                  size="large"
                  style="width: 150px"
                  :loading="studentLoading"
                  @change="handleStudentChange(item.studentId, index)"
                  class="mg_r_1"
                  :disabled="item.studentState === 'CANCELLED' || (isEdit && item.isOld)"
              >
                <el-option
                    v-for="item in students"
                    :key="`students${item.studentId}`"
                    :label="item.studentName"
                    :value="item.studentId"
                />
                <template v-if="!loading && !students.some(res => res.studentId === item.studentId) && item.studentId !== null" #header>
                  当前已选：
                  <el-option
                      :label="item.studentName"
                      :value="item.studentId"
                  />
                </template>

                <template #footer>
                  <div class="flex_center">
                    <el-pagination
                        size="small"
                        background
                        layout="prev, pager, next"
                        :total="totalStudent"
                        class="mt-4"
                        v-model:current-page="pageStudent"
                        v-model:page-size="pageSizeStudent"
                        @current-change="handleChangeStudentPage"
                    />
                  </div>
                </template>
              </el-select>
              <el-select
                  v-model="item.studentState"
                  placeholder="请选择状态"
                  size="large"
                  style="width: 150px"
                  @change="handleStudentStateChange(index)"
                  class="mg_r_1"
                  :disabled="ruleForm.lessonState === 'CANCELLED'"
              >
                <el-option
                    v-for="item in studentState"
                    :key="`studentState${item.studentState}`"
                    :label="item.stateName"
                    :value="item.stateId"
                />
              </el-select>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="删除"
                  placement="right"
                  @click.stop>
                <v-icon class="cursor-pointer" v-if="!item.isOld" color="error" icon="mdi-close" @click="handleRemoveStudent(index)"></v-icon>
              </el-tooltip>
            </div>
            <div class="flex_left">
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" :disabled="!isSelectTime || ruleForm.lessonState === 'CANCELLED'" @click="addStudent"></v-icon>
              <span class="tips_default">课堂学员上限{{studentLimit}}人</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label=" ">
          <div>
            <v-row>
              <v-col>
                <v-btn @click="resetForm">取消</v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary" @click="submit" :disabled="!$handleHasBtnPermission('all', 'lesson:add', 'lesson:edit')">保存</v-btn>
              </v-col>
            </v-row>
          </div>
        </el-form-item>
      </el-form>
    </v-container>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>